<template>
  <PageHeader />
  <main>
    <el-carousel
      class="background"
      height="480px"
      :interval="10000"
      trigger="click"
      :arrow="headerImages.length > 1 ? 'hover' : 'never'"
      :indicator-position="headerImages.length > 1 ? '' : 'none'"
      @change="(index) => (activeItem = index)"
    >
      <el-carousel-item v-for="(image, index) in headerImages" :key="index">
        <Transition :duration="{ enter: 0, leave: 1000 }">
          <img
            v-if="index === activeItem"
            :src="image.photoFilename"
            load="lazy"
            class="background__carousel_item"
            alt=""
          />
        </Transition>
      </el-carousel-item>
    </el-carousel>
    <div class="main-content">
      <slot />
    </div>
  </main>
</template>

<script lang="ts">
import PageHeader from '@/components/layout/Header.vue';
import usePartnerStore from '@/composables/store/usePartnerStore';
import { ElCarousel, ElCarouselItem } from 'element-plus';
import { defineComponent, ref } from 'vue';

export default defineComponent({
  components: { ElCarousel, ElCarouselItem, PageHeader },
  setup() {
    const { headerImages } = usePartnerStore();
    const activeItem = ref(0);
    return { headerImages, activeItem };
  },
});
</script>
<style lang="scss" scoped>
main {
  margin: 400px 0 35px 0;
}

.main-content {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

@include respond-max($small-devices) {
  .main-content {
    padding: 0 10px;
  }
}

.background {
  position: absolute;
  top: 100px;
  left: 0;
  width: 100%;
  height: 480px;
  background-color: var(--primary-color);

  &__carousel_item {
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
  }

  ::v-deep(.el-carousel__indicators.el-carousel__indicators--horizontal) {
    left: unset;
    right: 0;
  }
}

@media print {
  .background {
    display: none;
  }

  main {
    margin: 0 0 35px 0;
  }
}
</style>
